<template>
  <div
    class="itemMenu"
    :class="{ itemActive: item.active || active }"
    @mouseenter="mouseEnterItemActive"
    @mouseleave="mouseLeaveItemActive"
    @click="irA"
  >
    
    <el-tooltip :content="item.title" placement="right" :disabled="labels == true || isMobile" effect="dark" popper-class="tooltip">
      <div class="itemContent">
        <Icon :icon="item.icon" class="icon" />
        <span class="label" v-if="labels == true">{{ item.title }}</span>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Icon } from "@iconify/vue2";

export default {
  name: "PsItemMenu",
  data() {
    return {
      active: false,
    };
  },
  components: { Icon },
  props: ["item", "labels"],
  computed: {
    ...mapState(["isMobile"]),
  },
  methods: {
    ...mapMutations("routes", ["ACTIVATE_ITEM_MENU"]),
    ...mapMutations(["DRAWER_MENU", "LOGOUT"]),
    mouseEnterItemActive() {
      this.active = true;
    },
    mouseLeaveItemActive() {
      this.active = false;
    },
    irA() {
      this.ACTIVATE_ITEM_MENU(this.item.title);
      this.DRAWER_MENU(false);

      if (this.item.title == "Cerrar sesión") {
        this.LOGOUT();
        this.$router.replace("/");
      } else {
        if (this.$route.path !== this.item.route) {
          this.$router.push(this.item.route);
        }
      }
    },
  },
};
</script>

<style scoped>
.itemMenu {
  color: rgba(0, 0, 0, 0.4);
  display: flex;
  padding: 24px 0;
  transition: 0.2s ease-in-out all;
  position: relative;  
  font-family: 'Roboto', sans-serif;
}
a {
  text-decoration: none;
}
.icon {
  font-size: 2rem;
}

.itemActive {
  color: rgba(0, 0, 0, 1);
  font-weight: bold;
  position: relative;
}
.itemActive > i.icon {
  font-weight: semi-bold;
}
.itemContent {
  display: flex;
  align-items: center; 
}
.label {
  line-height: 30px;
  margin-left: 15px; 
  font-family: 'Roboto', sans-serif;
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .itemMenu {
    padding: 8px 0;
  }
  .icon {
    font-size: 1.7rem;
  }
}
</style>
